export const UPDATE = "modules/UPDATE";
export const UPDATE_ONE = "modules/UPDATE_ONE";
export const APPEND = "modules/APPEND";
export const EMPTY = "modules/EMPTY";
export const LOADING = "modules/LOADING";
